module.exports = __webpack_public_path__ + "img/iso1328-1-2013_fig08_profile-deviation-tip-and-root-relief.3f779b1c.png";